import { authSubsGet, authSubsPost } from "src/api/authSubs";
import {
  BioFlowAccountStatus,
  BioFlowHandoffStartRequest,
  BioFlowHandoffStartResponse,
  BioFlowOrderResponse,
  BioFlowPlanQuotation,
  BioFlowSubscriptionStatus,
  BioFlowVerifyCallbackResponse,
  CreateBioFlowOrderRequest,
  RegisterBioFlowCredentialsRequest,
  SUBSCRIPTION_PRODUCT_BIOFLOW,
} from "src/types/bioflow";

export const fetchBioFlowAccountStatus = (): Promise<BioFlowAccountStatus> =>
  authSubsGet<BioFlowAccountStatus>("/bioflow/account");

export const fetchBioFlowQuotations = (): Promise<BioFlowPlanQuotation[]> =>
  authSubsGet<BioFlowPlanQuotation[]>(
    `/subscription/quotation?product=${SUBSCRIPTION_PRODUCT_BIOFLOW}`,
  );

export const fetchBioFlowSubscriptionStatus = (): Promise<BioFlowSubscriptionStatus> =>
  authSubsGet<BioFlowSubscriptionStatus>(
    `/subscription/status?product=${SUBSCRIPTION_PRODUCT_BIOFLOW}`,
  );

export const createBioFlowOrder = (
  data: CreateBioFlowOrderRequest,
): Promise<BioFlowOrderResponse> =>
  authSubsPost<BioFlowOrderResponse>("/subscription/order", data);

export const repurchaseBioFlowOrder = (
  data?: { gateway?: "tap" | "myfatoorah" },
): Promise<BioFlowOrderResponse> =>
  authSubsPost<BioFlowOrderResponse>(
    `/subscription/order/repurchase?product=${SUBSCRIPTION_PRODUCT_BIOFLOW}`,
    data ?? {},
  );

export const startBioFlowHandoff = (
  data?: BioFlowHandoffStartRequest,
): Promise<BioFlowHandoffStartResponse> =>
  authSubsPost<BioFlowHandoffStartResponse>("/bioflow/handoff/start", data ?? {});

export const registerBioFlowCredentials = (
  data: RegisterBioFlowCredentialsRequest,
): Promise<BioFlowAccountStatus> =>
  authSubsPost<BioFlowAccountStatus>("/bioflow/register-credentials", data);

export const verifyBioFlowCallback = (
  callback: string,
): Promise<BioFlowVerifyCallbackResponse> =>
  authSubsPost<BioFlowVerifyCallbackResponse>("/bioflow/onboarding/verify-callback", {
    callback,
  });
